import React from 'react';
import styles from './styles.module.sass';
import cx from 'classnames';

interface TextBlockProps {
  children?: React.ReactNode;
  width?: number | string;
  className?: string;
}

const TextBlock: React.FC<TextBlockProps> = ({
  children,
  width = 650,
  className,
}) => (
  <div className={cx(styles.block, className)} style={{ maxWidth: width }}>
    {children}
  </div>
);

export default TextBlock;
